import { CommonModule } from "@angular/common";
import { Component, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { FormisForm, MCDialog, MCFieldExpressionsService, MCFormValidationService, MCResponse, RESPONSE_STATUS_CODE } from "@maslul/common-services";
import { MCButtonComponent, MCDialogComponent, MCFieldFormComponent } from "@maslul/common-components";
import { AttachmentsService } from "../../../../../services/pages/attachments/attachments";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { FormlyFieldConfig, FormlyModule } from "@ngx-formly/core";
import { ReactiveFormsModule } from "@angular/forms";
import { DialogModule } from 'primeng/dialog';
import cloneDeep from "clone-deep";
import { AttachmentsStore } from "../../../../../services/store/attachments";
import { TranslateService } from "@ngx-translate/core";
import { RequestApprovalTypeDetailsStore } from "../../../../../services/store/approval-type-details-store";
import { SendDialogComponent } from "../../components/send-dialog/send-dialog";
import { GeneralSkeletonComponent } from "../../components/general-skeleton/general-skeleton";
import { PageBaseComponent } from "../../../../shared/page-base";
import { FocusOnTabDirective } from "../../../../../services/shared/directives/focus-on-tab";
import { GeneralStore } from "../../../../../services/store/general";
import { TABS } from "../../../../../enum/request/TABS";
import { SendService } from "../../../../../services/general/send";

@Component({
    selector: 'mi-attachments',
    imports: [CommonModule,
        MCFieldFormComponent,
        ReactiveFormsModule,
        FormlyModule,
        MCButtonComponent,
        DialogModule,
        GeneralSkeletonComponent,
        MCDialogComponent,
        SendDialogComponent,
        FocusOnTabDirective
    ],
    templateUrl: './attachments.html',
    styleUrl: './attachments.scss',
    standalone: true,
    encapsulation: ViewEncapsulation.None,

})
export class AttachmentsComponent extends PageBaseComponent implements OnInit, OnDestroy {

    formisForm: FormisForm = new FormisForm();
    subscribtion: Subscription = new Subscription();
    displaySuccessDialog: boolean = false;
    tabsText: any;
    attachmentsText: any;
    genericText: any;
    dialogProperties: MCDialog = new MCDialog();
    isExistDeclaration: any;
    unionReqiestId: number = 0;
    isSuccessSend: boolean = false;
    isNoRelevantattachments: boolean = false;


    constructor(private attachmentsService: AttachmentsService
        , private attachmentsStore: AttachmentsStore
        , private formValidationService: MCFormValidationService
        , public override router: Router
        , private translateService: TranslateService
        , private requestApprovalTypeDetailsStore: RequestApprovalTypeDetailsStore
        , private generalStore: GeneralStore
        , private fieldExpressionsService: MCFieldExpressionsService
        , private sendService: SendService) {

        super(router);
    }


    ngOnInit() {
        this.init();
        this.initDialog();
        this.initFormisForm();
        this.initText();
    }

    init() {
        this.isExistDeclaration = this.requestApprovalTypeDetailsStore.getSnapshot().approvalTabs.includes(TABS.DECLARATIONS);
    }
    initDialog() {
        this.dialogProperties.breakpoints = {
            '960px': '75vw', // ברוחב 960px ומטה, רוחב הדיאלוג יהיה 75vw
            '640px': '80vw' // ברוחב 640px ומטה, רוחב הדיאלוג יהיה 80
        };
    }

    initText() {
        this.subscribtion.add(this.translateService.stream('generic').subscribe(translation => {
            this.genericText = translation;
        }));
        this.subscribtion.add(this.translateService.stream('tabs').subscribe(translation => {
            this.tabsText = translation;

        }));
        this.subscribtion.add(this.translateService.stream('common.pages.attachments').subscribe(translation => {
            this.attachmentsText = translation;

        }));
    }


    initFormisForm() {
        this.formisForm.options.formState = cloneDeep(this.generalStore.getSnapshot().formState);
        //this.formisForm.form = new FormGroup({});
        this.formisForm.model = cloneDeep(this.attachmentsStore.getSnapshot().formisFormModel);
        this.initFields();


    }
    initFields() {
        this.subscribtion.add(
            this.attachmentsService.getFields(this.formisForm)
                .subscribe((formisFormFields: Array<FormlyFieldConfig> | undefined) => {
                    if (formisFormFields) {
                        this.formisForm.fields = formisFormFields;
                        this.initIsNoRelevantattachments();
                    }
                }))
            ;
    }
    initIsNoRelevantattachments() {

        this.isNoRelevantattachments = !this.formisForm.fields.find(x => x.fieldGroup?.find(y => !this.fieldExpressionsService.hideExpression(this.formisForm.model, this.formisForm.options.formState, y)))

    }

    getNextLabel(): string {
        return this.isExistDeclaration ? this.genericText.next + ' >' : this.genericText.send;
    }

    back() {
        this.attachmentsStore.setFormisFormModel(cloneDeep(this.formisForm.model));
        this.navigation('request-details')
    }

    send() {

        this.sendService.send().subscribe({
            next: (res: MCResponse) => {
                this.dialogProperties.visible = true

                if (res && res.code === RESPONSE_STATUS_CODE.SUCCESS) {
                    this.unionReqiestId = res.data
                    this.isSuccessSend = true;
                }
                else {
                    this.isSuccessSend = false;
                }
            },
            error: () => {
                this.isSuccessSend = false;
                this.dialogProperties.visible = true

            }

        })
    }

    next() {
        const isValid = this.formisForm.form.valid;

        this.attachmentsStore.setFormisFormModel(cloneDeep(this.formisForm.model));

        if (isValid) {
            if (this.isExistDeclaration) {
                this.navigation('declarations')
            }
            else {
                this.send();

            }

        }
        else {
            this.formisForm.form.markAllAsTouched();
            const invalidFields = this.formValidationService.getInvalidControlsFlatMap(this.formisForm.form);
            console.log('attachments get invalid field', invalidFields);


        }
    }


    ngOnDestroy(): void {
        this.subscribtion.unsubscribe();
    }
}